import { useQuery } from "@apollo/client";
import { GET_CUSTOMER_TAGS } from "../../../../../gqls/customer";
import NewTag from "./newTag";
import CustomerTag from "./customerTag";
import { sort } from "fast-sort";

export default function CustomerTags() {
  const { data } = useQuery(GET_CUSTOMER_TAGS);
  const tags = sort(data?.customerTags || []).asc("name");

  return (
    <div className="flex flex-col gap-2">
      <h1 className="md:mb-4">고객 태그 목록</h1>
      <div className="flex flex-row gap-2 flex-wrap">
        {tags.map(tag => (
          <CustomerTag tag={tag} key={tag.id} />
        ))}
      </div>
      <NewTag />
    </div>
  );
}
